import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {},
    listItem: {
      '&:last-child:not($expanded)': {
        '& > div:first-child': {
          marginBottom: 0,
        },
      },
    },
    expanded: {
      marginBottom: SMALL_MARGIN,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    sublist: {
      paddingLeft: LARGE_MARGIN,
    },
    noItems: {
      color: colorsPalette.gray,
      fontSize: 16,
    },
  }),
);

export default useStyles;
